import App from "@/components/users";
import { wrapper } from "@/redux/store/store";
import { withCommonData } from "@/hocs/with-common-data";
import { withEhqPfe } from "@/hocs/with-ehq-pfe";
import { withParticipantData } from "@/hocs/with-participant-data";
import type { GetServerSideProps, GetServerSidePropsContext } from "next";
import EHQLayout from "@/components/shared/layouts/ehq/default";
import type { ReactElement } from "react";
import { SingleColumnLayout } from "@/storybook-components";

export default function Page() {
  return <App />;
}

Page.getLayout = function getLayout(page: ReactElement) {
  return (
    <EHQLayout>
      <SingleColumnLayout>{page}</SingleColumnLayout>
    </EHQLayout>
  );
};

export const getServerSideProps: GetServerSideProps = withCommonData(
  withEhqPfe(
    withParticipantData(
      wrapper.getServerSideProps(
        (store) => async (ctx: GetServerSidePropsContext) => {
          return {
            props: {}
          };
        }
      )
    )
  )
);
